import { render } from "./DemoView.vue?vue&type=template&id=59d2c1ad"
import script from "./DemoView.vue?vue&type=script&lang=js"
export * from "./DemoView.vue?vue&type=script&lang=js"

import "./DemoView.vue?vue&type=style&index=0&id=59d2c1ad&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__